import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import CountUp from "react-countup";

const Graph = (param) => {
  const [chartData, setChartData] = useState([]);
  const [chartCategory, setChartCategory] = useState([]);
  const [productCount, setProductCount] = useState(0);
  const [donutchartcustomerColors, setdonutchartcustomerColors] = useState([]);
  const [donutlabel, setdonutlabel] = useState([]);
  const [series, setseries] = useState([]);
  const linechartcustomerColors = ["#9fc5e8", "#f596fb", "#BDB395", "#75fb4c", "#FFC107", "#75fbfd"];

  useEffect(() => {
    setProductCount(param.product.length);
  }, [param.product]);

  useEffect(() => {
    if (param.data && param.data["chart"]) setChartData(param.data["chart"]);
    if (param.data && param.data["chartcategory"]) setChartCategory(param.data["chartcategory"]);

    let ser = [];
    let col = [];
    let lbl = [];
    for (const deal of (param.data["dealCount"] || [])) {
      let statusId = deal.sales_deal_status ? deal.sales_deal_status.id : 0;
      let result = !isNaN(parseFloat(deal.result)) ? parseFloat(deal.result) : 0;
      if (statusId === 3) {
        ser.push(result);
        col.push("#f596fb");
        lbl.push("BOOKING");
      }

      if (statusId === 4) {
        ser.push(result);
        col.push("#BDB395");
        lbl.push("KANTOR");
      }

      if (statusId === 5) {
        ser.push(result);
        col.push("#75fb4c");
        lbl.push("BANK");
      }

      if (statusId === 6) {
        ser.push(result);
        col.push("#FFC107");
        lbl.push("SP3K");
      }

      if (statusId === 7) {
        ser.push(result);
        col.push("#9ACBD0");
        lbl.push("SP3K FINAL");
      }

      if (statusId === 8) {
        ser.push(result);
        col.push("#75fbfd");
        lbl.push("AKAD");
      }
    }
    setdonutchartcustomerColors(col);
    setseries(ser);
    setdonutlabel(lbl);
  }, [param.data]);
  return (
    <React.Fragment>
      <Row>
        <Col sm={8}>
          <Card className="">
            <CardHeader className="border-0 align-items-center d-flex">
              <h4 className="card-title mb-0 flex-grow-1">GRAFIK PENJUALAN</h4>
              {/* <div className="d-flex gap-1">
            <button type="button" className="btn btn-soft-secondary btn-sm" onClick={() => { onChangeChartPeriod("all"); }}>
              ALL
            </button>
            <button type="button" className="btn btn-soft-secondary btn-sm" onClick={() => { onChangeChartPeriod("month"); }}>
              1M
            </button>
            <button type="button" className="btn btn-soft-secondary btn-sm" onClick={() => { onChangeChartPeriod("halfyear"); }}>
              6M
            </button>
            <button type="button" className="btn btn-soft-primary btn-sm" onClick={() => { onChangeChartPeriod("year"); }}>
              1Y
            </button>
          </div> */}
            </CardHeader>

            <CardHeader className="p-0 border-0 bg-soft-light">
              <Row className="g-0 text-center">
                <Col xs={6} sm={3}>
                  <div className="p-2 border border-dashed border-start-0">
                    <h5 className="mb-1">
                      <CountUp start={0} end={(param.data && param.data["sales_count"]) ?? 0} duration={3} separator="," />
                    </h5>
                    <p className="text-muted mb-0">Transaksi</p>
                  </div>
                </Col>
              </Row>
            </CardHeader>

            <CardBody className="p-0 pb-2">
              <div dir="ltr">
                <ReactApexChart
                  options={{
                    chart: {
                      height: 380,
                      type: "line",
                      toolbar: {
                        show: true,
                      },
                    },
                    stroke: {
                      curve: "straight",
                      dashArray: [0, 0, 0, 0, 0, 0],
                      width: [2, 2, 2, 2, 2, 2],
                    },
                    fill: {
                      opacity: [0.5, 1, 1, 1, 1, 1],
                    },
                    markers: {
                      size: [0, 0, 0, 0, 0, 0],
                      strokeWidth: 2,
                      hover: {
                        size: 4,
                      },
                    },
                    xaxis: {
                      categories: chartCategory,
                      axisTicks: {
                        show: false,
                      },
                      axisBorder: {
                        show: false,
                      },
                    },
                    grid: {
                      show: true,
                      xaxis: {
                        lines: {
                          show: true,
                        },
                      },
                      yaxis: {
                        lines: {
                          show: false,
                        },
                      },
                      padding: {
                        top: 0,
                        right: -2,
                        bottom: 15,
                        left: 10,
                      },
                    },
                    legend: {
                      show: true,
                      horizontalAlign: "center",
                      offsetX: 0,
                      offsetY: -5,
                      markers: {
                        width: 9,
                        height: 9,
                        radius: 6,
                      },
                      itemMargin: {
                        horizontal: 10,
                        vertical: 0,
                      },
                    },
                    plotOptions: {
                      bar: {
                        columnWidth: "30%",
                        barHeight: "70%",
                      },
                    },
                    colors: linechartcustomerColors,
                    tooltip: {
                      theme: 'light',
                      fillSeriesColor: true,
                      y: [
                        {
                          formatter: function (y) {
                            if (typeof y !== "undefined") {
                              return y;
                            }
                            return y;
                          },
                        },
                        {
                          formatter: function (y) {
                            if (typeof y !== "undefined") {
                              return y;
                            }
                            return y;
                          },
                        },
                        {
                          formatter: function (y) {
                            if (typeof y !== "undefined") {
                              return y;
                            }
                            return y;
                          },
                        },
                        {
                          formatter: function (y) {
                            if (typeof y !== "undefined") {
                              return y;
                            }
                            return y;
                          },
                        },
                        {
                          formatter: function (y) {
                            if (typeof y !== "undefined") {
                              return y;
                            }
                            return y;
                          },
                        },
                        {
                          formatter: function (y) {
                            if (typeof y !== "undefined") {
                              return y;
                            }
                            return y;
                          },
                        },
                      ],
                    },
                  }}
                  series={chartData}
                  type="line"
                  height="380"
                  className="apex-charts" />
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col sm={4}>
          <Card className="" style={{ height: "500px" }}>
            <CardHeader className="border-0 align-items-center d-flex">
              <h4 className="card-title mb-0 flex-grow-1">PERSENTASE PROGRESS KPR</h4>
            </CardHeader>
            <CardHeader className="p-0 border-0 bg-soft-light">
              <Row className="g-0 text-center">
                <Col xs={4} sm={4}>
                  <div className="p-3 border border-dashed border-start-0">
                    <h5 className="mb-1">
                      <CountUp start={0} end={productCount ?? 0} duration={3} separator="," />
                    </h5>
                    <p className="text-muted mb-0">Total Blok</p>
                  </div>
                </Col>
                <Col xs={4} sm={4}>
                  <div className="p-3 border border-dashed border-start-0">
                    <h5 className="mb-1"><CountUp start={0} prefix="" suffix={""} separator="." end={(param.data && param.data["book_count"] && param.data["book_count"]) ?? 0} decimals={0} duration={4} />
                    </h5>
                    <p className="text-muted mb-0">Dipesan</p>
                  </div>
                </Col>
                <Col xs={4} sm={4}>
                  <div className="p-3 border border-dashed border-start-0">
                    <h5 className="mb-1"><CountUp start={0} prefix="" suffix={""} separator="." end={(param.data && param.data["book_count"] && param.data["book_count"] && (productCount - param.data["book_count"])) ?? 0} decimals={0} duration={4} />
                    </h5>
                    <p className="text-muted mb-0">Blok Kosong</p>
                  </div>
                </Col>
              </Row>
            </CardHeader>
            <CardBody className="p-0 pt-5 pb-5">
              <ReactApexChart
                dir="ltr"
                options={{
                  labels: donutlabel,
                  colors: donutchartcustomerColors,
                  chart: {
                    width: 200,
                    type: 'donut',
                  },
                  stroke: {
                    width: 0,
                  },
                  plotOptions: {
                    pie: {
                      donut: {
                        labels: {
                          show: true,
                          total: {
                            showAlways: true,
                            show: true
                          }
                        }
                      }
                    }
                  },
                  dataLabels: {
                    formatter: function (val, opts) {
                      var name = opts.w.globals.labels[opts.seriesIndex];
                      return [name, val.toFixed(1) + '%'];
                    },
                    enabled: true,
                    style: {
                      colors: ['#111']
                    },
                    dropShadow: {
                      blur: 0,
                      opacity: 1
                    }
                  },
                  states: {
                    hover: {
                      filter: 'none'
                    }
                  },
                  theme: {
                    palette: 'palette2'
                  },
                  responsive: [{
                    breakpoint: 480,
                    options: {
                      chart: {
                        width: 200
                      },
                      legend: true
                    }
                  }],
                  legend: {
                    fontSize: '11px',
                    show: true,
                    style: {
                      color: "#333333",
                    },
                  }
                }}
                series={series}
                type="donut"
                height="280"
                className="apex-charts" />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Graph;
